import { DateTime } from '@ksyos/date-time';
import type { IPatientSearchResult } from './PatientSearchStartBar';

// Make sure all ISO dates are converted to YYYY-MM-DD format
export function normalizePatient(patient: IPatientSearchResult) {
    return {
        ...patient,
        birthDate: patient.birthDate ? DateTime.from(patient.birthDate).format('YYYY-MM-DD') : null,
        deceasedDate: patient.deceasedDate ? DateTime.from(patient.deceasedDate).format('YYYY-MM-DD') : null,
    };
}
